import { AxiosService } from 'src/axios/axios.service';
import type { tAxiosCustomConfig } from 'src/axios/axios.types';
import { parsePendingFollowUps } from './UpcomingSendsBar.functions';
import type { tPendingFollowUp } from './UpcomingSendsBar.types';

export const UpcomingSendsService = Object.freeze({
  /**
   * INT-1500 U12: the chat's scheduled messages that have not gone out, soonest
   * first. bff-web's GET /chat/:cid/follow-ups/pending, next to the
   * GET /chat/:cid/follow-ups the chat already loads its follow-ups from.
   * Rejects when the request fails; the caller hides the bar.
   */
  getPending: async function (
    chatId: string,
    config?: tAxiosCustomConfig,
  ): Promise<tPendingFollowUp[]> {
    const body = await AxiosService.get<unknown>(
      `/chat/${chatId}/follow-ups/pending`,
      config,
    );
    return parsePendingFollowUps(body);
  },
});
